export const setupGlobalMapKey = "maplibre-setup-global-map-key";
export const mapKey = "maplibre-map-key";
export const layerOrderAddKey = "maplibre-layer-order-add-key";
export const layerOrderRemoveKey = "maplibre-layer-order-remove-key";
